import { useState } from "react";
import { faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";
import mainstyle from "../../style/Main.module.css";
import AuthInputField from "../ui/input/AuthInputs";
import AuthPassInputField from "../ui/input/AuthInputs/AuthInputPassword";

const Step1PersonalInfo = ({ formData, onChange, errors }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <h3 className={mainstyle.FontSizeHeading20}>
        Join our community to get started
      </h3>

      <AuthInputField
        label="Email Address"
        name="email"
        type="email"
        value={formData?.email || ""}
        onChange={onChange}
        required
        error={errors.email}
      />

      <AuthInputField
        label="Phone"
        name="phone"
        value={formData?.phone || ""}
        onChange={onChange}
        required
        error={errors.phone}
      />

      <AuthPassInputField
        label="Password"
        name="password"
        type={showPassword ? "text" : "password"}
        value={formData?.password || ""}
        onChange={onChange}
        placeholder="Enter Password"
        icon={showPassword ? faEye : faEyeSlash}
        onIconClick={togglePasswordVisibility}
        required
        error={errors.password}
      />

      {errors.error && (
        <div className={mainstyle.errorMsgCenter}>{errors.error}</div>
      )}
    </div>
  );
};

export default Step1PersonalInfo;
